//imports
import {
    LOGIN_REQUEST,
    LOGIN_RESULT,
    LOGIN_FORGOT_PASSWORD_RESULT,
    LOGIN_FORGOT_PASSWORD_REQUEST,
    LOGIN_FORGOT_PASSWORD_OPEN_MODAL,
    LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT,
    LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST,
    LOGIN_CHANGE_PASSWORD_OPEN_MODAL,
    LOGIN_CHANGE_PASSWORD_REQUEST,
    LOGIN_CHANGE_PASSWORD_RESULT,
    LOGIN_CHECK_LOGIN_USER_BY_CODE,
    LOGIN_LOGOUT_REQUEST,
    LOGIN_LOGOUT_RESULT,
} from 'Redux/actionTypes';

export const loginRequest = (username, password, history) => ({
    type: LOGIN_REQUEST,
    payload: { username, password, history },
});

export const loginResult = (cognitoValues, showConfirm, error) => ({
    type: LOGIN_RESULT,
    payload: { cognitoValues, showConfirm, error }
});

export const loginForgotPasswordOpenModal = (open) => ({
    type: LOGIN_FORGOT_PASSWORD_OPEN_MODAL,
    payload: open
});

export const loginForgotPasswordRequest = (data) => ({
    type: LOGIN_FORGOT_PASSWORD_REQUEST,
    payload: data
});

export const loginForgotPasswordResult = (result) => ({
    type: LOGIN_FORGOT_PASSWORD_RESULT,
    payload: result
});

export const loginConfirmForgotPasswordRequest = (data) => ({
    type: LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST,
    payload: data
});

export const loginConfirmForgotPasswordResult = (result) => ({
    type: LOGIN_CONFIRM_FORGOT_PASSWORD_RESULT,
    payload: result
});

export const checkLoginUserByCode = (code, history) => ({
    type: LOGIN_CHECK_LOGIN_USER_BY_CODE,
    payload: { code, history }
});

export const loginOpenModalChangePassword = (values) => ({
    type: LOGIN_CHANGE_PASSWORD_OPEN_MODAL,
    payload: values
});

export const forceChangePasswordRequest = (values, history) => ({
    type: LOGIN_CHANGE_PASSWORD_REQUEST,
    payload: { values, history }
});

export const forceChangePasswordResult = (result) => ({
    type: LOGIN_CHANGE_PASSWORD_RESULT,
    payload: result
});

export const logoutRequest = (data) => ({
    type: LOGIN_LOGOUT_REQUEST,
    payload: data
});

export const logoutResult = (result) => ({
    type: LOGIN_LOGOUT_RESULT,
    payload: result
});




